__turbopack_context__.v({
  "accordionSlideOverwrite": "landingHeroCarousel-module-scss-module__4JbjOq__accordionSlideOverwrite",
  "carousel": "landingHeroCarousel-module-scss-module__4JbjOq__carousel",
  "fadeIn": "landingHeroCarousel-module-scss-module__4JbjOq__fadeIn",
  "fadeOut": "landingHeroCarousel-module-scss-module__4JbjOq__fadeOut",
  "logoContainer": "landingHeroCarousel-module-scss-module__4JbjOq__logoContainer",
  "logoImage": "landingHeroCarousel-module-scss-module__4JbjOq__logoImage",
  "logoWrapper": "landingHeroCarousel-module-scss-module__4JbjOq__logoWrapper",
  "scaleIn": "landingHeroCarousel-module-scss-module__4JbjOq__scaleIn",
  "scaleOut": "landingHeroCarousel-module-scss-module__4JbjOq__scaleOut",
  "zoomIn": "landingHeroCarousel-module-scss-module__4JbjOq__zoomIn",
  "zoomOut": "landingHeroCarousel-module-scss-module__4JbjOq__zoomOut",
});
